import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import React from "react";
import { TypedUseSelectorHook, createDispatchHook, createSelectorHook } from "react-redux";
import mainSlice from "./toasts/mainSlice";

export const ToasterContext = React.createContext(null);

const store = configureStore({
    reducer: {
        main: mainSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default store;

export type ToasterDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export const useToasterDispatch = createDispatchHook<ToasterDispatch>(ToasterContext);
export const useToasterSelector: TypedUseSelectorHook<RootState> = createSelectorHook(ToasterContext);
